(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vhalam-safa-banner-link')) {
    customElements.define('vhalam-safa-banner-link', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.querySelector('a')?.addEventListener('click', event => {
          const overview = document.getElementById('SafaServiceOverview');
          if (!overview) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          history.replaceState(null, '', event.currentTarget.hash);
          overview.focus({ preventScroll:true });
          this.finishScroll?.();
          const controller = new AbortController();
          let frame = 0;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const targetPosition = () => {
            const offset = parseFloat(getComputedStyle(overview).scrollMarginBlockStart) || 0;
            const target = window.scrollY + overview.getBoundingClientRect().top - offset;
            return Math.max(0, Math.min(target, document.documentElement.scrollHeight - window.innerHeight));
          };
          const animate = (duration) => {
            cancelAnimationFrame(frame);
            if (reducedMotion) {
              window.scrollTo({ top:targetPosition(), behavior:'instant' });
              frame = 0;
              return;
            }
            const origin = window.scrollY;
            const started = performance.now();
            const step = now => {
              const progress = Math.min(1, (now - started) / duration);
              const eased = progress < .5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
              window.scrollTo({ top:origin + (targetPosition() - origin) * eased, behavior:'instant' });
              frame = progress < 1 ? requestAnimationFrame(step) : 0;
            };
            frame = requestAnimationFrame(step);
          };
          const observer = new ResizeObserver(() => {
            if (!frame && Math.abs(window.scrollY - targetPosition()) > 2) animate(400);
          });
          observer.observe(document.body);
          const main = overview.closest('main');
          if (main) observer.observe(main);
          const timer = setTimeout(() => this.finishScroll?.(), 5000);
          this.finishScroll = () => {
            observer.disconnect();
            cancelAnimationFrame(frame);
            frame = 0;
            controller.abort();
            clearTimeout(timer);
            this.finishScroll = null;
          };
          for (const type of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
            window.addEventListener(type, () => this.finishScroll?.(), { signal:controller.signal, once:true, passive:true });
          }
          animate(1200);
        }, { signal:this.controller.signal, capture:true });
      }
      disconnectedCallback() { this.controller?.abort(); this.finishScroll?.(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('desktop-navigation')) {
    class DesktopNavigation extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.buttons = [...this.querySelectorAll('.desktop-navigation__toggle')];
        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

        for (const button of this.buttons) {
          button.addEventListener('click', () => this.toggle(button), { signal: this.controller.signal });

          const item = button.closest('[data-navigation-item]');
          item.addEventListener('mouseenter', () => {
            if (this.hoverQuery.matches) this.open(button);
          }, { signal: this.controller.signal });
          item.addEventListener('mouseleave', () => {
            if (this.hoverQuery.matches) this.close(button);
          }, { signal: this.controller.signal });
        }

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.closeAll();
        }, { signal: this.controller.signal });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const openButton = this.querySelector('.desktop-navigation__toggle[aria-expanded="true"]');
          if (!openButton) return;
          this.close(openButton);
          openButton.focus();
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      toggle(button) {
        if (button.hasAttribute('data-click-open')) {
          this.close(button);
          return;
        }
        this.open(button);
        button.setAttribute('data-click-open', '');
      }

      open(button) {
        this.closeAll(button);
        const submenu = document.getElementById(button.getAttribute('aria-controls'));
        if (!submenu) return;
        button.setAttribute('aria-expanded', 'true');
        button.closest('[data-navigation-item]')?.setAttribute('data-open', '');
        submenu.hidden = false;
      }

      close(button) {
        const submenu = document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-expanded', 'false');
        button.removeAttribute('data-click-open');
        button.closest('[data-navigation-item]')?.removeAttribute('data-open');
        if (submenu) submenu.hidden = true;
      }

      closeAll(exceptButton) {
        for (const button of this.buttons) {
          if (button !== exceptButton) this.close(button);
        }
      }
    }

    customElements.define('desktop-navigation', DesktopNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-collections-mirror"] && !Shopify.designMode) return;
  try {
    
class SimpleCollectionsFlyout extends HTMLElement {
  connectedCallback() {
    for (const [index, item] of [...this.querySelectorAll('.simple-collections-item')].entries()) {
      item.style.setProperty('--simple-collection-index', index + 1);
    }
    for (const toggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      toggle.hidden = !panel?.querySelector('.simple-collections__subcategory[href]');
    }
    this.toggleClicked = (event) => this.handleToggle(event);
    this.keyPressed = (event) => this.handleKeydown(event);
    this.panelTransitioned = (event) => this.handleTransitionEnd(event);
    this.viewportResized = () => this.updateOpenWidth();
    this.pageShown = () => {
      requestAnimationFrame(() => this.revealCurrent());
    };
    this.addEventListener('click', this.toggleClicked);
    this.addEventListener('keydown', this.keyPressed);
    this.addEventListener('transitionend', this.panelTransitioned);
    window.addEventListener('resize', this.viewportResized);
    window.addEventListener('pageshow', this.pageShown);
    this.openCurrentParent();
  }
  openCurrentParent() {
    const currentLink = this.querySelector('.simple-collections__subcategory[aria-current="page"]')
      || this.querySelector('.simple-collections__parent-link[aria-current="page"]');
    const currentPanel = currentLink?.closest('.simple-collections-item')?.querySelector('[data-subcategories-panel]');
    if (!currentPanel?.querySelector('.simple-collections__subcategory[href]')) return;
    const currentToggle = this.querySelector(`[aria-controls="${CSS.escape(currentPanel.id)}"]`);
    if (!currentToggle) return;
    for (const toggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      if (panel) this.setPanelState(toggle, panel, toggle === currentToggle, true);
    }
    requestAnimationFrame(() => this.revealCurrent());
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.toggleClicked);
    this.removeEventListener('keydown', this.keyPressed);
    this.removeEventListener('transitionend', this.panelTransitioned);
    window.removeEventListener('resize', this.viewportResized);
    window.removeEventListener('pageshow', this.pageShown);
  }
  handleToggle(event) {
    const toggle = event.target.closest('.simple-collections__parent-toggle');
    if (!toggle || !this.contains(toggle)) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (!panel) return;
    if (!panel.querySelector('.simple-collections__subcategory[href]')) {
      window.location.assign(toggle.dataset.parentUrl);
      return;
    }
    const opening = toggle.getAttribute('aria-expanded') !== 'true';
    for (const parentToggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const parentPanel = this.querySelector(`#${CSS.escape(parentToggle.getAttribute('aria-controls'))}`);
      if (parentPanel) this.setPanelState(parentToggle, parentPanel, opening && parentToggle === toggle);
    }
    if (opening) this.revealToggle(toggle);
  }
  handleKeydown(event) {
    if (event.key !== 'Escape') return;
    const toggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
    if (!toggle) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (!panel) return;
    event.preventDefault();
    this.setPanelState(toggle, panel, false);
    toggle.focus();
  }
  revealToggle(toggle) {
    const item = toggle.closest('.shopify-block');
    if (!item) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const target = Math.max(0, this.scrollLeft + item.getBoundingClientRect().left - this.getBoundingClientRect().left - 16);
    this.scrollTo({ left: target, behavior: reducedMotion ? 'auto' : 'smooth' });
  }
  revealCurrent() {
    const current = this.querySelector('.simple-collections__subcategory[aria-current="page"]')
      || this.querySelector('.simple-collections__parent-link[aria-current="page"]');
    if (!current) return;
    const rect = current.getBoundingClientRect();
    const viewport = this.getBoundingClientRect();
    const target = this.scrollLeft + rect.left + rect.width / 2 - viewport.left - this.clientWidth / 2;
    this.scrollTo({ left: Math.max(0, Math.min(target, this.scrollWidth - this.clientWidth)), behavior: 'instant' });
  }
  setPanelState(toggle, panel, opening, instant = false) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (instant) panel.style.transition = 'none';
    if (opening) {
      const wasHidden = panel.hidden;
      panel.hidden = false;
      panel.inert = false;
      if (wasHidden && !instant && !reducedMotion) {
        panel.style.width = '0px';
        panel.offsetWidth;
      }
    } else {
      panel.inert = true;
    }
    toggle.setAttribute('aria-expanded', String(opening));
    panel.style.width = opening ? `${panel.querySelector('.simple-collections__subcategory-list').scrollWidth}px` : '0px';
    if (!opening && (instant || reducedMotion || panel.getBoundingClientRect().width === 0)) panel.hidden = true;
    if (instant) {
      panel.offsetWidth;
      requestAnimationFrame(() => panel.style.removeProperty('transition'));
    }
  }
  handleTransitionEnd(event) {
    const panel = event.target;
    if (!panel.matches?.('[data-subcategories-panel]') || event.propertyName !== 'width') return;
    const toggle = this.querySelector(`[aria-controls="${CSS.escape(panel.id)}"]`);
    if (toggle?.getAttribute('aria-expanded') === 'false') panel.hidden = true;
  }
  updateOpenWidth() {
    const toggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
    if (!toggle) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (panel) panel.style.width = `${panel.querySelector('.simple-collections__subcategory-list').scrollWidth}px`;
  }
}
if (!customElements.get('vhalam-collection-flyout')) customElements.define('vhalam-collection-flyout', SimpleCollectionsFlyout);

class VhalamCategoryMirror extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.load();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  async load() {
    const endpoint = new URL(this.dataset.sourceUrl, window.location.origin);
    endpoint.searchParams.set('section_id', this.dataset.sourceSection);
    const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewThemeId) endpoint.searchParams.set('preview_theme_id', previewThemeId);

    try {
      const response = await fetch(endpoint, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: this.controller.signal
      });
      let categories;
      if (response.ok) {
        const documentFromHome = new DOMParser().parseFromString(await response.text(), 'text/html');
        categories = documentFromHome.querySelector('.simple-collections');
      }
      if (!categories?.querySelector('vhalam-collection-flyout')) {
        endpoint.searchParams.delete('section_id');
        const homepageResponse = await fetch(endpoint, {
          credentials: 'same-origin',
          cache: 'no-store',
          signal: this.controller.signal
        });
        if (!homepageResponse.ok) throw new Error('Shared categories unavailable');
        const documentFromHome = new DOMParser().parseFromString(await homepageResponse.text(), 'text/html');
        categories = documentFromHome.querySelector('.simple-collections');
      }
      if (!categories?.querySelector('vhalam-collection-flyout')) throw new Error('Homepage category section missing');

      const currentPath = window.location.pathname.replace(/\/+$/, '');
      for (const link of categories.querySelectorAll('.simple-collections__parent-link[href], .simple-collections__subcategory[href]')) {
        const linkPath = new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/+$/, '');
        if (linkPath !== currentPath) continue;
        link.setAttribute('aria-current', 'page');
        if (link.classList.contains('simple-collections__parent-link')) {
          const item = link.closest('.simple-collections-item');
          item?.classList.add('active');
          item?.setAttribute('data-current-parent', '');
        }
      }

      this.replaceChildren(categories);
      this.setAttribute('aria-busy', 'false');
      requestAnimationFrame(() => {
        if (categories.isConnected) categories.classList.add('viewport-entered');
      });
    } catch (error) {
      if (error.name === 'AbortError') return;
      this.querySelector('[data-category-mirror-fallback]')?.removeAttribute('hidden');
      this.setAttribute('aria-busy', 'false');
      console.error('Shared homepage categories could not load', error);
    }
  }
}

if (!customElements.get('vhalam-category-mirror')) customElements.define('vhalam-category-mirror', VhalamCategoryMirror);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-collections"] && !Shopify.designMode) return;
  try {
    
class SimpleCollectionsFlyout extends HTMLElement {
  connectedCallback() {
    for (const [index, item] of [...this.querySelectorAll('.simple-collections-item')].entries()) {
      item.style.setProperty('--simple-collection-index', index + 1);
    }
    for (const toggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      toggle.hidden = !panel?.querySelector('.simple-collections__subcategory[href]');
    }
    this.toggleClicked = (event) => this.handleToggle(event);
    this.keyPressed = (event) => this.handleKeydown(event);
    this.panelTransitioned = (event) => this.handleTransitionEnd(event);
    this.viewportResized = () => this.updateOpenWidth();
    this.pageShown = () => {
      const currentToggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
      if (currentToggle) requestAnimationFrame(() => this.revealToggle(currentToggle));
    };
    this.addEventListener('click', this.toggleClicked);
    this.addEventListener('keydown', this.keyPressed);
    this.addEventListener('transitionend', this.panelTransitioned);
    window.addEventListener('resize', this.viewportResized);
    window.addEventListener('pageshow', this.pageShown);
    this.openCurrentParent();
  }
  openCurrentParent() {
    const currentLink = this.querySelector('.simple-collections__parent-link[aria-current="page"]')
      || this.querySelector('.simple-collections__subcategory[aria-current="page"]');
    const currentPanel = currentLink?.closest('.simple-collections-item')?.querySelector('[data-subcategories-panel]');
    if (!currentPanel?.querySelector('.simple-collections__subcategory[href]')) return;
    const currentToggle = this.querySelector(`[aria-controls="${CSS.escape(currentPanel.id)}"]`);
    if (!currentToggle) return;
    for (const toggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      if (panel) this.setPanelState(toggle, panel, toggle === currentToggle, true);
    }
    requestAnimationFrame(() => this.revealToggle(currentToggle));
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.toggleClicked);
    this.removeEventListener('keydown', this.keyPressed);
    this.removeEventListener('transitionend', this.panelTransitioned);
    window.removeEventListener('resize', this.viewportResized);
    window.removeEventListener('pageshow', this.pageShown);
  }
  handleToggle(event) {
    const toggle = event.target.closest('.simple-collections__parent-toggle');
    if (!toggle || !this.contains(toggle)) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (!panel) return;
    if (!panel.querySelector('.simple-collections__subcategory[href]')) {
      window.location.assign(toggle.dataset.parentUrl);
      return;
    }
    const opening = toggle.getAttribute('aria-expanded') !== 'true';
    for (const parentToggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const parentPanel = this.querySelector(`#${CSS.escape(parentToggle.getAttribute('aria-controls'))}`);
      if (parentPanel) this.setPanelState(parentToggle, parentPanel, opening && parentToggle === toggle);
    }
    if (opening) this.revealToggle(toggle);
  }
  handleKeydown(event) {
    if (event.key !== 'Escape') return;
    const toggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
    if (!toggle) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (!panel) return;
    event.preventDefault();
    this.setPanelState(toggle, panel, false);
    toggle.focus();
  }
  revealToggle(toggle) {
    const item = toggle.closest('.shopify-block');
    if (!item) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const target = Math.max(0, this.scrollLeft + item.getBoundingClientRect().left - this.getBoundingClientRect().left - 16);
    this.scrollTo({ left: target, behavior: reducedMotion ? 'auto' : 'smooth' });
  }
  setPanelState(toggle, panel, opening, instant = false) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (instant) panel.style.transition = 'none';
    if (opening) {
      const wasHidden = panel.hidden;
      panel.hidden = false;
      panel.inert = false;
      if (wasHidden && !instant && !reducedMotion) {
        panel.style.width = '0px';
        panel.offsetWidth;
      }
    } else {
      panel.inert = true;
    }
    toggle.setAttribute('aria-expanded', String(opening));
    panel.style.width = opening ? `${panel.querySelector('.simple-collections__subcategory-list').scrollWidth}px` : '0px';
    if (!opening && (instant || reducedMotion || panel.getBoundingClientRect().width === 0)) panel.hidden = true;
    if (instant) {
      panel.offsetWidth;
      requestAnimationFrame(() => panel.style.removeProperty('transition'));
    }
  }
  handleTransitionEnd(event) {
    const panel = event.target;
    if (!panel.matches?.('[data-subcategories-panel]') || event.propertyName !== 'width') return;
    const toggle = this.querySelector(`[aria-controls="${CSS.escape(panel.id)}"]`);
    if (toggle?.getAttribute('aria-expanded') === 'false') panel.hidden = true;
  }
  updateOpenWidth() {
    const toggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
    if (!toggle) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (panel) panel.style.width = `${panel.querySelector('.simple-collections__subcategory-list').scrollWidth}px`;
  }
}
if (!customElements.get('vhalam-collection-flyout')) customElements.define('vhalam-collection-flyout', SimpleCollectionsFlyout);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhalam-safa-quick-link"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vhalam-safa-quick-link')) {
    customElements.define('vhalam-safa-quick-link', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.querySelector('a')?.addEventListener('click', event => {
          const enquiry = document.getElementById('SafaServiceEnquiry');
          if (!enquiry) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          enquiry.open = true;
          history.replaceState(null, '', event.currentTarget.hash);
          enquiry.scrollIntoView({ behavior:'instant', block:'start' });
          enquiry.querySelector('summary')?.focus({ preventScroll:true });
        }, { signal:this.controller.signal, capture:true });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhalam-safa-service"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vhalam-safa-service')) {
    customElements.define('vhalam-safa-service', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.defaultPickerTitle ||= this.querySelector('[data-selected-title]').textContent;
        const options = { signal: this.controller.signal };
        this.querySelector('[data-enquiry-trigger]')?.addEventListener('click', event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          const enquiry = this.querySelector('.safa-service__enquiry');
          enquiry.open = true;
          history.replaceState(null, '', event.currentTarget.hash);
          enquiry.scrollIntoView({ behavior:'instant', block:'start' });
          enquiry.querySelector('summary')?.focus({ preventScroll:true });
        }, { ...options, capture:true });
        this.querySelector('[data-safa-search]')?.addEventListener('input', event => {
          const term = event.target.value.trim().toLocaleLowerCase();
          let count = 0;
          this.querySelectorAll('[data-safa-option]').forEach(button => { button.hidden = !button.textContent.toLocaleLowerCase().includes(term); if (!button.hidden) count += 1; });
          this.querySelector('[data-no-results]').hidden = count > 0;
        }, options);
        this.querySelectorAll('[data-safa-option]').forEach(button => button.addEventListener('click', () => this.selectSafa(button), options));
        this.querySelector('.safa-service__enquiry')?.addEventListener('toggle', event => { if (event.target.open) this.connectForm(); }, options);
        this.connectForm();
      }
      selectSafa(button) {
        this.querySelectorAll('[data-safa-option]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
        this.querySelector('[data-selected-title]').textContent = button.dataset.title;
        this.querySelector('.safa-service__picker').open = false;
        this.selectedSafa = button.dataset.title;
        this.updateFormField();
        this.renderSelection(button.dataset.title);
        this.querySelector('.safa-service__picker-summary').focus();
        this.dispatchEvent(new CustomEvent('safa:selected', { bubbles:true, detail:{ title:button.dataset.title, url:button.dataset.productUrl } }));
      }
      renderSelection(title) {
        const image = this.querySelector('[data-selected-image]');
        const option = [...this.querySelectorAll('[data-safa-option]')].find(item => item.dataset.title === title);
        const thumbnail = option?.querySelector('img');
        this.querySelector('[data-selection-status]').textContent = title || '';
        image.hidden = !thumbnail;
        if (thumbnail) image.src = thumbnail.currentSrc || thumbnail.src;
        else image.removeAttribute('src');
      }
      enhanceForm(host) {
        const root = host.shadowRoot;
        const form = root?.querySelector('form');
        if (!form || form.dataset.safaEasyReady) return;
        const day = root.querySelector('input[aria-labelledby="label-DD"]');
        const month = root.querySelector('input[aria-labelledby="label-MM"]');
        const year = root.querySelector('input[aria-labelledby="label-YYYY"]');
        const timeField = root.getElementById('custom#event_time_and_time_zone');
        const countryField = root.getElementById('custom#country');
        const stateField = root.getElementById('custom#city_state');
        const venueField = root.getElementById('custom#venue_address');
        const quantity = root.getElementById('custom#number_of_people_safas');
        if (![day, month, year, timeField, countryField, stateField, venueField, quantity].every(Boolean)) return;
        form.dataset.safaEasyReady = 'true';
        const signal = this.controller.signal;
        const wrapper = field => {
          let node = field;
          while (node.parentElement && node.parentElement !== form) node = node.parentElement;
          return node;
        };
        [...form.children].forEach((node, index) => node.style.order = String(index * 10));
        const write = (field, value) => {
          Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(field, value);
          field.dispatchEvent(new Event('input', { bubbles:true, composed:true }));
          field.dispatchEvent(new Event('change', { bubbles:true, composed:true }));
        };
        const source = this.querySelector('[data-easy-fields]').content;
        const mount = (selector, field, order) => {
          const control = source.querySelector(selector).cloneNode(true);
          const original = wrapper(field);
          original.before(control);
          original.style.display = 'none';
          control.style.order = String(order);
          return control.querySelector('input,select');
        };
        if (!root.querySelector('[data-easy-style]')) root.append(source.querySelector('[data-easy-style]').cloneNode(true));
        const date = mount('[data-easy-date]', day, 50);
        const time = mount('[data-easy-time]', timeField, 60);
        const state = mount('[data-easy-state]', stateField, 80);
        const country = mount('[data-easy-country]', countryField, 90);
        wrapper(this.formField).style.display = 'none';
        time.parentElement.after(wrapper(venueField), state.parentElement, country.parentElement);
        wrapper(venueField).style.order = '70';
        wrapper(quantity).style.order = '100';
        const notes = root.querySelector('textarea');
        if (notes) wrapper(notes).style.order = '110';
        const submit = form.querySelector('button[type="submit"]');
        if (submit) submit.style.order = '120';
        if (year.value && month.value && day.value) date.value = year.value + '-' + month.value.padStart(2, '0') + '-' + day.value.padStart(2, '0');
        time.value = /^\d{2}:\d{2}$/.test(timeField.value) ? timeField.value : '';
        date.addEventListener('change', () => {
          const [y, m, d] = date.value.split('-');
          write(day, d || '');
          write(month, m || '');
          write(year, y || '');
        }, { signal });
        time.addEventListener('change', () => write(timeField, time.value), { signal });
        const chooseState = state.options[0].textContent;
        const populateStates = (preserve = '') => {
          const provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');
          state.replaceChildren(new Option(chooseState, ''));
          if (!country.value || country.value === '---') {
            state.disabled = true;
            write(countryField, '');
            write(stateField, '');
            return;
          }
          state.disabled = false;
          for (const [value, label] of provinces) state.add(new Option(label, value));
          if (!provinces.length) state.add(new Option('Not applicable', 'Not applicable'));
          state.value = [...state.options].some(option => option.value === preserve) ? preserve : '';
          if (!provinces.length) state.value = 'Not applicable';
          write(countryField, country.value);
          write(stateField, state.value);
        };
        country.value = countryField.value || 'India';
        populateStates(stateField.value);
        country.addEventListener('change', () => populateStates(), { signal });
        state.addEventListener('change', () => write(stateField, state.value), { signal });
        quantity.min = '100';
        quantity.step = '1';
        quantity.required = true;
        quantity.inputMode = 'numeric';
        if (!quantity.value) write(quantity, '100');
        quantity.addEventListener('blur', () => {
          if (quantity.value && Number(quantity.value) < 100) write(quantity, '100');
        }, { signal });
        form.addEventListener('submit', event => {
          const invalid = [date, time, state, country, quantity].find(control => !control.checkValidity());
          if (!invalid) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          invalid.reportValidity();
        }, { capture:true, signal });
      }
      connectForm() {
        clearInterval(this.formTimer);
        let attempts = 0;
        const connect = () => {
          const host = this.querySelector('.safa-service__form shopify-forms-embed');
          const field = host?.shadowRoot?.getElementById('custom#preferred_safa');
          if (field) {
            if (this.formField !== field) {
              field.addEventListener('input', () => {
                this.selectedSafa = field.value;
                this.querySelector('[data-selected-title]').textContent = field.value || this.defaultPickerTitle;
                this.querySelectorAll('[data-safa-option]').forEach(option => option.setAttribute('aria-pressed', String(option.dataset.title === field.value)));
                this.renderSelection(field.value);
              }, { signal:this.controller.signal });
            }
            this.formField = field;
            this.enhanceForm(host);
            this.renderSelection(this.selectedSafa || field.value);
            const loading = this.querySelector('[data-form-loading]');
            const fallback = this.querySelector('[data-form-fallback]');
            if (loading) loading.hidden = true;
            if (fallback) fallback.hidden = true;
            host.style.setProperty('--form-field-border', '0 0 0 1px #746a61');
            host.style.setProperty('--form-placeholder-color', '#746a61');
            host.style.setProperty('--form-field-border-radius', '12px');
            host.style.setProperty('--button-border-radius', '12px');
            host.style.setProperty('--form-background-color', '#fffdf8');
            host.style.setProperty('--inline-container-max-width', '100%');
            host.style.setProperty('--forms-base-font-size', '16px');
            host.style.setProperty('--forms-body-font', `normal 400 16px ${getComputedStyle(this).fontFamily}`);
            this.updateFormField();
            clearInterval(this.formTimer);
            return true;
          }
          attempts += 1;
          if (attempts >= 120) {
            clearInterval(this.formTimer);
            const loading = this.querySelector('[data-form-loading]');
            const fallback = this.querySelector('[data-form-fallback]');
            if (loading) loading.hidden = true;
            if (fallback) fallback.hidden = false;
          }
          return false;
        };
        if (!connect()) this.formTimer = setInterval(connect, 500);
      }
      updateFormField() {
        if (!this.formField?.isConnected || !this.selectedSafa) return;
        const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
        setter.call(this.formField, this.selectedSafa);
        this.formField.dispatchEvent(new Event('input', { bubbles:true, composed:true }));
        this.formField.dispatchEvent(new Event('change', { bubbles:true, composed:true }));
      }
      disconnectedCallback() { this.controller?.abort(); clearInterval(this.formTimer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
